import $ from 'jquery';
export default function initializeNavigation() {

    //======================================================================================================
    //Menu beim scroll verkleinen
    //======================================================================================================
    window.onscroll = function() {scrollFunction()};
    function scrollFunction() {
        if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
            $('.img-desktop').addClass("no-display-img");
            $('.img-desktop').addClass("opacity-true");
            $('.menu-desktop').addClass("menu-scroll-top");
            $('.category_level_0').addClass("dropdown-scroll-top");

        } else {

            $('.img-desktop').removeClass("no-display-img");
            $('.img-desktop > img:first-child').removeClass("transition-img");
            $('.menu-desktop').removeClass("menu-scroll-top");
            $('.category_level_0').removeClass("dropdown-scroll-top");
            setTimeout(function () {
                $('.img-desktop').removeClass("opacity-true");
            }, 500);
        }
        if ($(".dropdown").hasClass("open")) {
            $(".dropdown").removeClass("open");
        }

    }

    //======================================================================================================
    //Dropdown nur beim Hover anzeigen
    //======================================================================================================
    $(".menu-desktop .dropdown").on('mouseover',function(){
        $(this).addClass("open");
    });
    $(".menu-desktop .dropdown").on('mouseout',function(){
        $(this).removeClass("open");
    });
}
